const discrepancy = {
  discrepancy_configuration: "Discrepancy Configuration",
  discrepancy: "Discrepancy",
  predefined_erp: "Predefined ERP",
  matching_documents: "Matching documents",
  total: "Total",
  connected_documents: "connected documents",
  external_systems: "External Systems",
  header_fields: "Header Fields",
  line_items: "Line Items",
  total_amount: "Total Amount",
  total_without_tax: "Total w/o Tax",
  total_tax: "Total Tax",
};
export default discrepancy;
